import { FC } from "react";
import { TableCell, TableHeadCell } from "@rothoblaas/design-system";
import AdminCrudTable from "../../../../components/ui/AdminCrudTable";
import useI18n from "../../../../hooks/useTranslations";
import { GroovingType } from "../../../../http/deckDesigner/types/groovingTypes";
import useDeckGroovingTypesApi from "../../../../http/deckDesigner/useGroovingTypes";
import GroovingTypeForm from "./GroovingTypeForm";

const AdminGroovingTypes: FC = () => {
  const i18n = useI18n();
  const groovingTypesApi = useDeckGroovingTypesApi();

  return (
    <AdminCrudTable<GroovingType>
      filterPrefix="grooving_types"
      useList={groovingTypesApi.useDeckGroovingTypes}
      head={<TableHeadCell align="left">{i18n.translation.common.name}</TableHeadCell>}
      renderRow={(item) => <TableCell>{item.name}</TableCell>}
      renderForm={(item, onClose) => <GroovingTypeForm groovingType={item} onClose={onClose} />}
    />
  );
};

export default AdminGroovingTypes;
